import { computed } from 'vue';
import { useRoute } from '#app/composables/router';
import { useWorkspaceEntityStore } from '#layers/runtime/public';

/**
 * A page is currently active outside of rendering itself, for example being open in the page builder.
 */
export function useCurrentPageNotRendered() {
	const store = useWorkspaceEntityStore();
	const route = useRoute();

	const currentPageNotRendered = computed(() => route.params.pageId ? store.MonospacePage.peekFirst(route.params.pageId as string) : null);

	return {
		currentPageNotRendered,
	};
}
